import { Menu } from "../../models/menu";

 export const menuListResponse: Menu= {
    "navigation": [
        {
            "cms_page_code": "",
            "code": "home",
            "external_link": "",
            "title": "Homepage",
            "item_type": "code",
            "children": []
        },
        {
            "cms_page_code": "",
            "code": "avc-dashboard",
            "external_link": "",
            "title": "AVC Dashboard",
            "item_type": "code",
            "children": []
        },
        {
            "cms_page_code": "",
            "code": "dashboard",
            "external_link": "",
            "title": "Dashboard",
            "item_type": "code",
            "children": []
        },
        {
            "cms_page_code": "",
            "code": "avc-creditline",
            "external_link": "",
            "title": "AVC Creditline",
            "item_type": "code",
            "children": []
        },
        {
            "cms_page_code": "",
            "code": "amadeus-plus-me",
            "external_link": "",
            "title": "Amadeus+Me",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me\/details",
                    "external_link": "",
                    "title": "Program details",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me\/enrollment",
                    "external_link": "",
                    "title": "Enroll now",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me\/bonuspoints",
                    "external_link": "",
                    "title": "Points Balance",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me\/statuspoints",
                    "external_link": "",
                    "title": "Status points",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me\/participation",
                    "external_link": "",
                    "title": "My agent's participation",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "amadeus-plus-me-gift-catalog",
                    "external_link": "",
                    "title": "Gift catalog",
                    "item_type": "external_link",
                    "children": []
                }
            ]
        },
        {
            "cms_page_code": "",
            "code": "account",
            "external_link": "",
            "title": "My Account",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "account\/profile",
                    "external_link": "",
                    "title": "Profile",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "account\/agency",
                    "external_link": "",
                    "title": "Agency details",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "account\/invoices",
                    "external_link": "",
                    "title": "Invoices",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "account\/avc-invoices",
                    "external_link": "",
                    "title": "AVC Invoices",
                    "item_type": "code",
                    "children": []
                }
            ]
        }
    ],
    "footer": [
        {
            "cms_page_code": "",
            "code": "about",
            "external_link": "",
            "title": "About Amadeus",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "aboutamadeus",
                    "external_link": "https:\/\/amadeus.com",
                    "title": "About Amadeus",
                    "item_type": "external_link",
                    "children": []
                }
            ]
        },
        {
            "cms_page_code": "",
            "code": "account",
            "external_link": "",
            "title": "My Account",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "account\/profile",
                    "external_link": "",
                    "title": "My Profile",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "account\/agency",
                    "external_link": "",
                    "title": "My Agency details",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "account\/invoices",
                    "external_link": "",
                    "title": "My Invoices",
                    "item_type": "code",
                    "children": []
                }
            ]
        },
        {
            "cms_page_code": "",
            "code": "business",
            "external_link": "",
            "title": "My Business",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "dashboard",
                    "external_link": "",
                    "title": "Dashboard",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "SERVICE_HUB",
                    "external_link": "",
                    "title": "Service Hub",
                    "item_type": "external_link",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "COMMUNITY",
                    "external_link": "",
                    "title": "Live Travel Community",
                    "item_type": "external_link",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "connect",
                    "external_link": "https:\/\/pdt.accounts.sellingplatformconnect.amadeus.com\/LoginService\/authorize?service=SECO_SSO&redirect_uri=https%3A%2F%2Facceptance.sellingplatformconnect.amadeus.com%2FLoginService%2FloginFromSAMLSSO.jsp%3FSITE%3DLOGINURL%26LANGUAGE%3DGB%26nonce%3Djhsd",
                    "title": "Selling Platform Connect",
                    "item_type": "external_link",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "EDENRED_SUPPORT",
                    "external_link": "",
                    "title": "Edenred Support",
                    "item_type": "external_link",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "PLUSME_SUPPORT",
                    "external_link": "",
                    "title": "+Me Support",
                    "item_type": "external_link",
                    "children": []
                }
            ]
        },
        {
            "cms_page_code": "",
            "code": "contactus",
            "external_link": "",
            "title": "Contact us",
            "item_type": "title",
            "children": [
                {
                    "cms_page_code": "",
                    "code": "contact",
                    "external_link": "",
                    "title": "Contact",
                    "item_type": "code",
                    "children": []
                },
                {
                    "cms_page_code": "",
                    "code": "faq",
                    "external_link": "",
                    "title": "F.A.Q.",
                    "item_type": "code",
                    "children": []
                }
            ]
        }
    ],
    "legal": [
        {
            "cms_page_code": "terms-of-use",
            "code": "terms",
            "external_link": "",
            "title": "Terms of use",
            "item_type": "cms_page",
            "children": []
        },
        {
            "cms_page_code": "cookies",
            "code": "cookies",
            "external_link": "",
            "title": "Cookies Policy",
            "item_type": "cms_page",
            "children": []
        },
        {
            "cms_page_code": "privacy-policy",
            "code": "privacy",
            "external_link": "",
            "title": "Privacy Policy",
            "item_type": "cms_page",
            "children": []
        },
        {
            "cms_page_code": "registration-amadeus-plus-me-agreement",
            "code": "amadeus-plus-me-terms-and-conditions",
            "external_link": "",
            "title": "Amadeus+Me Terms",
            "item_type": "cms_page",
            "children": []
        },
        {
            "cms_page_code": "amadeus-plus-me-privacy-notice",
            "code": "amadeus-plus-me-privacy-notice",
            "external_link": "",
            "title": "Amadeus+Me - Privacy notice",
            "item_type": "cms_page",
            "children": []
        },
        {
            "cms_page_code": "registration-agreement",
            "code": "registration-agreement",
            "external_link": "",
            "title": "Terms and conditions",
            "item_type": "cms_page",
            "children": []
        }
    ]
};  

export const layout: any = {
        "home_page_tiles": [
            {
                "module": "dashboard",
                "size": "medium"
            },
            {
                "module": "sso",
                "size": "small"
            },
            {
                "module": "taskmanager",
                "size": "medium"
            },
            {
                "module": "news",
                "size": "large"
            }
        ]
}
